import { PromptBoxDefaultButton } from "./prompt-box.component";

export class PromptBoxModel {
    lblTitle?: string;
    lblSubtitle?: string;
    lblConfirmButton?: string = 'Confirmar';
    lblCancelButton?: string = 'Cancelar';
    color?: string = '#5AB8CA';
    onConfirm?: (text: string) => void;
    onCancel?: Function;
    defaultButton?: PromptBoxDefaultButton = PromptBoxDefaultButton.cancelar;
    showCancelButton?: boolean = true;
    isRequired?: boolean = true;
    placeHolder?: string = ''
    defaultValue?: string;
}